if (!window.jQuery) {
  window.jQuery = window.$ = require("jquery");
}

require("jquery-ui/ui/widgets/datepicker");

// DCLG specific JS
var DataGrid = require("./dclg/dataGrid");
var forms = require("./dclg/forms");
require("./dclg/expandCollapse");
require("./dclg/dialogPolyfill");
require("./dclg/conditionalCheckbox");
require("./dclg/facets");
require("./dclg/activeFacets");
require("./dclg/slidingPanel");
require("./dclg/closeNotification");
require("./dclg/controllers/index");
require("./dclg/chosenSelect");
require("./dclg/ajaxChosenSelect");
require("./dclg/ajaxUpdateSelect");
require("./dclg/fileUploadHandler");
require("./dclg/tabs");
require("./dclg/navigationalSelect");
require("./dclg/tableDeadlineSubmission");
require("./dclg/jsTable");
require("./dclg/userDetail");
require("./dclg/startTransactionReview");
require("./dclg/jsOptions");
require("./dclg/freeTextSearch");
require("./dclg/addGridQueryParamsOnclick");
require("./dclg/downloadXmlOnClick");
require("./dclg/conditionallyRevealChosen");
require("./dclg/revealIfActive");
require("./dclg/financialYear");
require("./dclg/warningPage");
require("./dclg/collectionRequestPage");
require("./dclg/downloadTransactionGraph");
require("./dclg/summaryChart");
require("./dclg/grantSections.js");
require("./dclg/dashboardFeedback.js");
require("./dclg/assignTester.js");
require("./dclg/usersPage.js");
require("./dclg/ledgerEditClickEvent.js");
require("./dclg/tableVendorCodes.js");
require("./dclg/tablePaymentMethod.js");
require("./dclg/exportToDapOnClick.js");
require("./dclg/downloadOrganisationsOnClick.js");
require("./dclg/manageTransactionsReview.js");
require("./dclg/sessionTimeoutPopup.js");
require("./dclg/userAuditPopup.js");
require("./dclg/approvalThresholds.js");
require("./dclg/userDetailsAccessGroup.js");
require("./dclg/certifier-journey.js");
require("./dclg/showLoadingIndicator.js");
require("./dclg/viewAllViewFewer");
require("./dclg/organisationFilterSelect");
require("./dclg/submissionReportOverviewChart");
require("./dclg/tableFilters/FiltersManager.ts");

// Initialisation
// ------------------------------



var $dataGridContainer = $(".data-grid");

if ($dataGridContainer.length) {
  $dataGridContainer.each(function () {
    // Configuration for the dataGrid is set within an HTML5 data-grid attribute.
    var dataGridConfig = $(this).data("grid");
    var thymeleafGeneratedUrl = $(this).siblings(".grid-load-url").val();

    if (!$.isEmptyObject(thymeleafGeneratedUrl)) {
      dataGridConfig.endpoints.loadData.url = thymeleafGeneratedUrl;
    }
    new DataGrid(
      $(this),
      dataGridConfig.options,
      dataGridConfig.endpoints
    );
  });
}


// Expand/collapse
$(".js-expander").expandCollapse();

// Sliding panel
$(".show-filters").slidingPanel();

// Toggle full-screen view
$(function () {
  var $formBuilderActionEl = $("#form-builder-fullscreen");
  var $elementsToHide = $(
      ".govuk-generic-header, " +
      ".govuk-service-navigation, " +
      ".govuk-breadcrumbs, " +
      ".delta-footer"
  );

  forms.addFullScreenControl(
    $formBuilderActionEl,
    $elementsToHide,
    $("#embedded-form-builder")
  );
});

// Notification boxes with close icons
$(".js-banner-with-close").closeNotification();

// Conditional checkbox fields
$(".js-conditional-checkbox").conditionalCheckbox();

// Conditionally-revealed chosen-js fields
$(".js-bound-to-condition").conditionallyRevealChosen();

var $dataConditional = $(".js-data-conditional-button");
if ($dataConditional.length) {
  $dataConditional.attr("disabled", "disabled");
}

// Facets
$(".filter-selector").facet();
$(".active-filters").activeFacets();

// --------------------------------------------------------
// Nav-select - currently used for updating the 'dataSource' choice
// --------------------------------------------------------
$(".nav-select").navSelect();

// ------------------------------
// Register page controllers
// call gridPageCtrl
// ------------------------------

var $controllers = $(".govuk-main-wrapper");

if ($controllers.length) {
  $controllers.each(function () {
    $(this).gridPageCtrl();
  });
}
// -----------------------------
// Chossen-js ... for Tags
// -----------------------------
$(document).ready(function () {
  var $chosenField = $(".chosen-select");
  $chosenField.chosenSelect();
  $chosenField.ajaxChosenSelect();
});

var $ajaxUpdateSelect = $(".js-update-select");
if ($ajaxUpdateSelect.length) $ajaxUpdateSelect.ajaxUpdateSelect();

// ------------------------------
// jQuery UI components
// ------------------------------

$("input.form-control-date:enabled").datepicker({
  showOn: "focus", // no trigger button created
  buttonImageOnly: false,
  buttonText: "Select date",
  dateFormat: "dd/mm/yy",
  beforeShow: function (dateText, obj) {
    setTimeout(function () {
      //The following changes have been made to resolve the title redundancy issue with prev and next field of the calendar.
      $("#ui-datepicker-div").find(".ui-datepicker-prev span").text("MM");
      $("#ui-datepicker-div").find(".ui-datepicker-next span").text("MM");
    }, 0);
  },
});

// -------------------------------
//   File Upload
// ---------------------------------

$(".js-fileUpload-checkbox").fileUploadCheckBox();

// -----------------------------
// File Upload control
// -----------------------------
$(".file-upload-container").fileUploadHandler();

// -----------------------------
// Free Text Search
// -----------------------------

$("#search-textfield").freeTextSearch();

$(".js-addGridQueryParamsOnclick").addGridQueryParamsOnclick();

$(".js-exportToDapOnClick") // Button using this hidden in DEL-4377
    .exportToDapOnClick();
$(".js-downloadOrganisationsOnClick").downloadOrganisationsOnClick();

$(".js-financialYear").financialYear();

$(".js-warningPage").warningPage();

$(".js-collectionRequestPage").collectionRequestPage();

$(".js-downloadXmlOnClick").downloadXmlOnClick();

$(".js-grantSections").grantSections();

$(".js-dashboardFeedback").dashboardFeedback();

$(".js-assignTester").assignTester();

$(".js-usersPage").usersPage();

$(".js-ledgerEditClickEvent").ledgerEditClickEvent();

// -----------------------------
// deadline submission
// -----------------------------

$(".js-table-deadline-submission").tableDeadlineSubmission();

// -----------------------------
// jsTable
// -----------------------------
var $jstable = $(".js-table");
var jstableConfig = $jstable.data("config") || {};
$jstable.jsTable(jstableConfig);

// -----------------------------
// jsOptions
// -----------------------------
var $jsopts = $(".js-option-provider");

var jsoptsConfig = $jsopts.data("config") || {};
$jsopts.jsOptions(jsoptsConfig);

// reveal div if checked.
$(".reveal-if-active").revealIfActive();

// numeric input validation
$(".js-numbers-only").keyup(function () {
  this.value = this.value.replace(/\D+/g, "");
  if (this.value != "") this.value = parseInt(this.value).toLocaleString();
});

// ------------------------------------
// Transaction Review
// ------------------------------------
$(".start-transaction-review").startTransactionReview();

if (document.getElementById('code-mirror-text-area')) {
  CodeMirror.fromTextArea(document.getElementById('code-mirror-text-area'), {
    readOnly: true,
    mode: "xml"
  });
}
